module.exports = __webpack_public_path__ + "img/account-icon-02.f58fc78b.svg";